// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formkit-outer[data-invalid]~.label[data-v-107cbb88]{color:var(--color-error)}.formkit-outer:hover~.label[data-v-107cbb88]{color:var(--color-black)}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
